import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { User, User_$reflection, AuthError_$reflection, Persona__get_Claims, Persona__get_Name, AuthToken_$reflection, Persona_$reflection } from "../Shopfoo.Domain.Types/Security.js";
import { tuple_type, lambda_type, unit_type, int32_type, list_type, string_type, class_type, union_type, option_type, record_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { SKU_$reflection, Lang_$reflection } from "../Shopfoo.Domain.Types/Common.js";
import { User_errorDetailLevel, ApiError_FromError_Z53E47AF1, ApiError_$reflection } from "./Errors.js";
import { Translations_$reflection, PageCode_$reflection, TranslationsModule_Empty } from "../Shopfoo.Domain.Types/Translations.js";
import { bind, defaultArg, unwrap } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { Result_Map, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { SearchedBook_$reflection, Provider_$reflection, Product_$reflection, BookAuthor_$reflection } from "../Shopfoo.Domain.Types/Catalog.js";
import { Sale_$reflection, SalesStats_$reflection, Prices_$reflection } from "../Shopfoo.Domain.Types/Sales.js";
import { ReceiveSupplyInput_$reflection, Stock_$reflection, PurchasePrices_$reflection } from "../Shopfoo.Domain.Types/Warehouse.js";
import { AppTranslations__Fill_Z288CEB4, AppTranslations__get_Translations, AppTranslations_$ctor, AppTranslations_$reflection } from "./Translations.js";
import { now } from "../fable_modules/fable-library-js.4.24.0/Date.js";

export class AuthPersona extends Record {
    constructor(Persona, Token) {
        super();
        this.Persona = Persona;
        this.Token = Token;
    }
}

export function AuthPersona_$reflection() {
    return record_type("Shopfoo.Shared.Remoting.AuthPersona", [], AuthPersona, () => [["Persona", Persona_$reflection()], ["Token", AuthToken_$reflection()]]);
}

export function AuthPersona__get_Name(this$) {
    return Persona__get_Name(this$.Persona);
}

export function AuthPersona__get_Claims(this$) {
    return Persona__get_Claims(this$.Persona);
}

/**
 * Defines how routes are generated on server and mapped from client.
 * E.g. api/Home/Index
 */
export function Route_builder(pageName, methodName) {
    return `/api/${pageName}/${methodName}`;
}

export class Request$1 extends Record {
    constructor(Token, Lang, Body) {
        super();
        this.Token = Token;
        this.Lang = Lang;
        this.Body = Body;
    }
}

export function Request$1_$reflection(gen0) {
    return record_type("Shopfoo.Shared.Remoting.Request`1", [gen0], Request$1, () => [["Token", option_type(AuthToken_$reflection())], ["Lang", Lang_$reflection()], ["Body", gen0]]);
}

export class ServerError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ApiError", "AuthError"];
    }
}

export function ServerError_$reflection() {
    return union_type("Shopfoo.Shared.Remoting.ServerError", [], ServerError, () => [[["Item", ApiError_$reflection()]], [["Item", AuthError_$reflection()]]]);
}

function ResponseBuilder_$007CTranslationsOrEmpty$007C(_arg) {
    if (_arg.tag === 1) {
        return TranslationsModule_Empty;
    }
    else {
        return _arg.fields[0];
    }
}

export function ResponseBuilder_plain(user) {
    return {
        ApiError(error, key) {
            return new FSharpResult$2(1, [new ServerError(0, [ApiError_FromError_Z53E47AF1(error, User_errorDetailLevel(user), unwrap(key))])]);
        },
        Ok(response) {
            return new FSharpResult$2(0, [response]);
        },
    };
}

export function ResponseBuilder_withTranslations(user, _arg) {
    const activePatternResult = ResponseBuilder_$007CTranslationsOrEmpty$007C(_arg);
    return {
        ApiError(error, key) {
            return new FSharpResult$2(1, [new ServerError(0, [ApiError_FromError_Z53E47AF1(error, User_errorDetailLevel(user), unwrap(key))])]);
        },
        Ok(response) {
            return Result_Map((response_1) => [response_1, activePatternResult], new FSharpResult$2(0, [response]));
        },
    };
}

export class QueryDataAndTranslations$1 extends Record {
    constructor(Query, TranslationPages) {
        super();
        this.Query = Query;
        this.TranslationPages = TranslationPages;
    }
}

export function QueryDataAndTranslations$1_$reflection(gen0) {
    return record_type("Shopfoo.Shared.Remoting.QueryDataAndTranslations`1", [gen0], QueryDataAndTranslations$1, () => [["Query", gen0], ["TranslationPages", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [PageCode_$reflection()])]]);
}

export class CatalogApi_GetBooksDataResponse extends Record {
    constructor(Authors, Tags) {
        super();
        this.Authors = Authors;
        this.Tags = Tags;
    }
}

export function CatalogApi_GetBooksDataResponse_$reflection() {
    return record_type("Shopfoo.Shared.Remoting.CatalogApi.GetBooksDataResponse", [], CatalogApi_GetBooksDataResponse, () => [["Authors", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [BookAuthor_$reflection()])], ["Tags", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])]]);
}

export class CatalogApi_GetProductsResponse extends Record {
    constructor(Products) {
        super();
        this.Products = Products;
    }
}

export function CatalogApi_GetProductsResponse_$reflection() {
    return record_type("Shopfoo.Shared.Remoting.CatalogApi.GetProductsResponse", [], CatalogApi_GetProductsResponse, () => [["Products", list_type(Product_$reflection())]]);
}

export class CatalogApi_GetProductResponse extends Record {
    constructor(Product) {
        super();
        this.Product = Product;
    }
}

export function CatalogApi_GetProductResponse_$reflection() {
    return record_type("Shopfoo.Shared.Remoting.CatalogApi.GetProductResponse", [], CatalogApi_GetProductResponse, () => [["Product", option_type(Product_$reflection())]]);
}

export class CatalogApi_SearchRequest$1 extends Record {
    constructor(SearchTerm) {
        super();
        this.SearchTerm = SearchTerm;
    }
}

export function CatalogApi_SearchRequest$1_$reflection(gen0) {
    return record_type("Shopfoo.Shared.Remoting.CatalogApi.SearchRequest`1", [gen0], CatalogApi_SearchRequest$1, () => [["SearchTerm", string_type]]);
}

export class CatalogApi_SearchResponse$1 extends Record {
    constructor(Items, TotalCount) {
        super();
        this.Items = Items;
        this.TotalCount = (TotalCount | 0);
    }
}

export function CatalogApi_SearchResponse$1_$reflection(gen0) {
    return record_type("Shopfoo.Shared.Remoting.CatalogApi.SearchResponse`1", [gen0], CatalogApi_SearchResponse$1, () => [["Items", list_type(gen0)], ["TotalCount", int32_type]]);
}

export class CatalogApi_CatalogApi extends Record {
    constructor(GetBooksData, GetProducts, GetProduct, SaveProduct, AddProduct, SearchAuthors, SearchBooks) {
        super();
        this.GetBooksData = GetBooksData;
        this.GetProducts = GetProducts;
        this.GetProduct = GetProduct;
        this.SaveProduct = SaveProduct;
        this.AddProduct = AddProduct;
        this.SearchAuthors = SearchAuthors;
        this.SearchBooks = SearchBooks;
    }
}

export function CatalogApi_CatalogApi_$reflection() {
    return record_type("Shopfoo.Shared.Remoting.CatalogApi.CatalogApi", [], CatalogApi_CatalogApi, () => [["GetBooksData", lambda_type(Request$1_$reflection(unit_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [CatalogApi_GetBooksDataResponse_$reflection(), ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", CatalogApi_GetBooksDataResponse_$reflection()]], [["ErrorValue", ServerError_$reflection()]]])]))], ["GetProducts", lambda_type(Request$1_$reflection(QueryDataAndTranslations$1_$reflection(Provider_$reflection())), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [tuple_type(CatalogApi_GetProductsResponse_$reflection(), Translations_$reflection()), ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", tuple_type(CatalogApi_GetProductsResponse_$reflection(), Translations_$reflection())]], [["ErrorValue", ServerError_$reflection()]]])]))], ["GetProduct", lambda_type(Request$1_$reflection(QueryDataAndTranslations$1_$reflection(SKU_$reflection())), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [tuple_type(CatalogApi_GetProductResponse_$reflection(), Translations_$reflection()), ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", tuple_type(CatalogApi_GetProductResponse_$reflection(), Translations_$reflection())]], [["ErrorValue", ServerError_$reflection()]]])]))], ["SaveProduct", lambda_type(Request$1_$reflection(Product_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ServerError_$reflection()]]])]))], ["AddProduct", lambda_type(Request$1_$reflection(Product_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ServerError_$reflection()]]])]))], ["SearchAuthors", lambda_type(Request$1_$reflection(CatalogApi_SearchRequest$1_$reflection(BookAuthor_$reflection())), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [CatalogApi_SearchResponse$1_$reflection(BookAuthor_$reflection()), ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", CatalogApi_SearchResponse$1_$reflection(BookAuthor_$reflection())]], [["ErrorValue", ServerError_$reflection()]]])]))], ["SearchBooks", lambda_type(Request$1_$reflection(CatalogApi_SearchRequest$1_$reflection(SearchedBook_$reflection())), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [CatalogApi_SearchResponse$1_$reflection(SearchedBook_$reflection()), ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", CatalogApi_SearchResponse$1_$reflection(SearchedBook_$reflection())]], [["ErrorValue", ServerError_$reflection()]]])]))]]);
}

export class HomeApi_HomeIndexResponse extends Record {
    constructor(Personas) {
        super();
        this.Personas = Personas;
    }
}

export function HomeApi_HomeIndexResponse_$reflection() {
    return record_type("Shopfoo.Shared.Remoting.HomeApi.HomeIndexResponse", [], HomeApi_HomeIndexResponse, () => [["Personas", list_type(AuthPersona_$reflection())]]);
}

export class HomeApi_GetTranslationsRequest extends Record {
    constructor(Lang, PageCodes) {
        super();
        this.Lang = Lang;
        this.PageCodes = PageCodes;
    }
}

export function HomeApi_GetTranslationsRequest_$reflection() {
    return record_type("Shopfoo.Shared.Remoting.HomeApi.GetTranslationsRequest", [], HomeApi_GetTranslationsRequest, () => [["Lang", Lang_$reflection()], ["PageCodes", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [PageCode_$reflection()])]]);
}

export class HomeApi_GetTranslationsResponse extends Record {
    constructor(Lang, Translations) {
        super();
        this.Lang = Lang;
        this.Translations = Translations;
    }
}

export function HomeApi_GetTranslationsResponse_$reflection() {
    return record_type("Shopfoo.Shared.Remoting.HomeApi.GetTranslationsResponse", [], HomeApi_GetTranslationsResponse, () => [["Lang", Lang_$reflection()], ["Translations", Translations_$reflection()]]);
}

export class HomeApi_HomeApi extends Record {
    constructor(Index, GetTranslations) {
        super();
        this.Index = Index;
        this.GetTranslations = GetTranslations;
    }
}

export function HomeApi_HomeApi_$reflection() {
    return record_type("Shopfoo.Shared.Remoting.HomeApi.HomeApi", [], HomeApi_HomeApi, () => [["Index", lambda_type(Request$1_$reflection(QueryDataAndTranslations$1_$reflection(unit_type)), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [tuple_type(HomeApi_HomeIndexResponse_$reflection(), Translations_$reflection()), ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", tuple_type(HomeApi_HomeIndexResponse_$reflection(), Translations_$reflection())]], [["ErrorValue", ServerError_$reflection()]]])]))], ["GetTranslations", lambda_type(Request$1_$reflection(HomeApi_GetTranslationsRequest_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [HomeApi_GetTranslationsResponse_$reflection(), ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", HomeApi_GetTranslationsResponse_$reflection()]], [["ErrorValue", ServerError_$reflection()]]])]))]]);
}

export class PricesApi_GetPricesResponse extends Record {
    constructor(Prices) {
        super();
        this.Prices = Prices;
    }
}

export function PricesApi_GetPricesResponse_$reflection() {
    return record_type("Shopfoo.Shared.Remoting.PricesApi.GetPricesResponse", [], PricesApi_GetPricesResponse, () => [["Prices", option_type(Prices_$reflection())]]);
}

export class PricesApi_GetPurchasePricesResponse extends Record {
    constructor(Stats) {
        super();
        this.Stats = Stats;
    }
}

export function PricesApi_GetPurchasePricesResponse_$reflection() {
    return record_type("Shopfoo.Shared.Remoting.PricesApi.GetPurchasePricesResponse", [], PricesApi_GetPurchasePricesResponse, () => [["Stats", PurchasePrices_$reflection()]]);
}

export class PricesApi_GetSalesStatsResponse extends Record {
    constructor(Stats) {
        super();
        this.Stats = Stats;
    }
}

export function PricesApi_GetSalesStatsResponse_$reflection() {
    return record_type("Shopfoo.Shared.Remoting.PricesApi.GetSalesStatsResponse", [], PricesApi_GetSalesStatsResponse, () => [["Stats", SalesStats_$reflection()]]);
}

export class PricesApi_PriceCommand extends Record {
    constructor(SKU) {
        super();
        this.SKU = SKU;
    }
}

export function PricesApi_PriceCommand_$reflection() {
    return record_type("Shopfoo.Shared.Remoting.PricesApi.PriceCommand", [], PricesApi_PriceCommand, () => [["SKU", SKU_$reflection()]]);
}

export class PricesApi_PricesApi extends Record {
    constructor(AdjustStock, DetermineStock, GetPrices, GetPurchasePrices, GetSalesStats, InputSale, SavePrices, MarkAsSoldOut, ReceiveSupply, RemoveListPrice) {
        super();
        this.AdjustStock = AdjustStock;
        this.DetermineStock = DetermineStock;
        this.GetPrices = GetPrices;
        this.GetPurchasePrices = GetPurchasePrices;
        this.GetSalesStats = GetSalesStats;
        this.InputSale = InputSale;
        this.SavePrices = SavePrices;
        this.MarkAsSoldOut = MarkAsSoldOut;
        this.ReceiveSupply = ReceiveSupply;
        this.RemoveListPrice = RemoveListPrice;
    }
}

export function PricesApi_PricesApi_$reflection() {
    return record_type("Shopfoo.Shared.Remoting.PricesApi.PricesApi", [], PricesApi_PricesApi, () => [["AdjustStock", lambda_type(Request$1_$reflection(Stock_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ServerError_$reflection()]]])]))], ["DetermineStock", lambda_type(Request$1_$reflection(SKU_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Stock_$reflection(), ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", Stock_$reflection()]], [["ErrorValue", ServerError_$reflection()]]])]))], ["GetPrices", lambda_type(Request$1_$reflection(SKU_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [PricesApi_GetPricesResponse_$reflection(), ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", PricesApi_GetPricesResponse_$reflection()]], [["ErrorValue", ServerError_$reflection()]]])]))], ["GetPurchasePrices", lambda_type(Request$1_$reflection(SKU_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [PricesApi_GetPurchasePricesResponse_$reflection(), ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", PricesApi_GetPurchasePricesResponse_$reflection()]], [["ErrorValue", ServerError_$reflection()]]])]))], ["GetSalesStats", lambda_type(Request$1_$reflection(SKU_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [PricesApi_GetSalesStatsResponse_$reflection(), ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", PricesApi_GetSalesStatsResponse_$reflection()]], [["ErrorValue", ServerError_$reflection()]]])]))], ["InputSale", lambda_type(Request$1_$reflection(Sale_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ServerError_$reflection()]]])]))], ["SavePrices", lambda_type(Request$1_$reflection(Prices_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ServerError_$reflection()]]])]))], ["MarkAsSoldOut", lambda_type(Request$1_$reflection(PricesApi_PriceCommand_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ServerError_$reflection()]]])]))], ["ReceiveSupply", lambda_type(Request$1_$reflection(ReceiveSupplyInput_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ServerError_$reflection()]]])]))], ["RemoveListPrice", lambda_type(Request$1_$reflection(PricesApi_PriceCommand_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ServerError_$reflection()]]])]))]]);
}

export class AdminApi_AdminApi extends Record {
    constructor(ResetProductCache) {
        super();
        this.ResetProductCache = ResetProductCache;
    }
}

export function AdminApi_AdminApi_$reflection() {
    return record_type("Shopfoo.Shared.Remoting.AdminApi.AdminApi", [], AdminApi_AdminApi, () => [["ResetProductCache", lambda_type(Request$1_$reflection(unit_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ServerError_$reflection()]]])]))]]);
}

export class RootApi extends Record {
    constructor(Admin, Catalog, Home, Prices) {
        super();
        this.Admin = Admin;
        this.Catalog = Catalog;
        this.Home = Home;
        this.Prices = Prices;
    }
}

export function RootApi_$reflection() {
    return record_type("Shopfoo.Shared.Remoting.RootApi", [], RootApi, () => [["Admin", AdminApi_AdminApi_$reflection()], ["Catalog", CatalogApi_CatalogApi_$reflection()], ["Home", HomeApi_HomeApi_$reflection()], ["Prices", PricesApi_PricesApi_$reflection()]]);
}

export class DelayedMessageHandling extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Drop", "EmitImmediately"];
    }
}

export function DelayedMessageHandling_$reflection() {
    return union_type("Shopfoo.Shared.Remoting.DelayedMessageHandling", [], DelayedMessageHandling, () => [[], []]);
}

export class UnitTestSession extends Record {
    constructor(DelayedMessageHandling, MockedApi, Now) {
        super();
        this.DelayedMessageHandling = DelayedMessageHandling;
        this.MockedApi = MockedApi;
        this.Now = Now;
    }
}

export function UnitTestSession_$reflection() {
    return record_type("Shopfoo.Shared.Remoting.UnitTestSession", [], UnitTestSession, () => [["DelayedMessageHandling", DelayedMessageHandling_$reflection()], ["MockedApi", RootApi_$reflection()], ["Now", option_type(class_type("System.DateTime"))]]);
}

export class FullContext extends Record {
    constructor(User, Token, Translations, UnitTestSession) {
        super();
        this.User = User;
        this.Token = Token;
        this.Translations = Translations;
        this.UnitTestSession = UnitTestSession;
    }
}

export function FullContext_$reflection() {
    return record_type("Shopfoo.Shared.Remoting.FullContext", [], FullContext, () => [["User", User_$reflection()], ["Token", option_type(AuthToken_$reflection())], ["Translations", AppTranslations_$reflection()], ["UnitTestSession", option_type(UnitTestSession_$reflection())]]);
}

export function FullContext_get_Default() {
    return new FullContext(new User(0, []), undefined, AppTranslations_$ctor(), undefined);
}

export function FullContext__get_Lang(this$) {
    return AppTranslations__get_Translations(this$.Translations).Lang;
}

export function FullContext__get_Now(this$) {
    return defaultArg(bind((_arg) => _arg.Now, this$.UnitTestSession), now());
}

export function FullContext__FillTranslations_Z288CEB4(this$, translations) {
    return new FullContext(this$.User, this$.Token, AppTranslations__Fill_Z288CEB4(this$.Translations, translations), this$.UnitTestSession);
}

export function FullContext__ResetTranslations(this$) {
    return new FullContext(this$.User, this$.Token, AppTranslations_$ctor(), this$.UnitTestSession);
}

export function FullContext__WithAnonymousUser(this$) {
    return new FullContext(new User(0, []), undefined, this$.Translations, this$.UnitTestSession);
}

export function FullContext__WithPersona_Z485AB5E3(this$, persona) {
    return new FullContext(new User(1, [AuthPersona__get_Name(persona), AuthPersona__get_Claims(persona)]), persona.Token, this$.Translations, this$.UnitTestSession);
}

